import { render, staticRenderFns } from "./RetailZone.vue?vue&type=template&id=53b8f94b&scoped=true"
import script from "./RetailZone.vue?vue&type=script&lang=js"
export * from "./RetailZone.vue?vue&type=script&lang=js"
import style0 from "./RetailZone.vue?vue&type=style&index=0&id=53b8f94b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b8f94b",
  null
  
)

export default component.exports